import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageServiceX {
  private currentLang: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['fr', 'en']);
    this.translate.setDefaultLang('fr');

    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localeEn, 'en');

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/fr|en/) ? browserLang : 'fr');
    this.currentLang.next(browserLang)
  }

  public get getCurrentLang(): string {
    return this.currentLang.value;
  }

  switchLanguage(languague: string) {
    this.translate.use(languague).subscribe((data) => {
      console.log('RESULTAT DU LANGUAGE TOGGLE : ', data);
      this.currentLang.next(languague);
    });
    console.log('In use language :', this.translate.currentLang);
  }
}
